import { EBankAccountType } from "../bank-accounts/EBankAccountType";
import { zSchema } from "../schema-validation";

export const postFundingSourceRequestSchema = zSchema.object({
  account_number: zSchema.string(),
  account_type: zSchema.nativeEnum(EBankAccountType),
  company_id: zSchema.string(),
  customer_account_id: zSchema.string(),
  partner_id: zSchema.string(),
  routing_number: zSchema.string(),
  testMode: zSchema.boolean(),
  token: zSchema.string().optional(),
  teller_account_id: zSchema.string().optional(),
  teller_enrollment_id: zSchema.string().optional(),
  institution: zSchema.string().optional(),
});

export type TPostFundingSourceRequestSchema = zSchema.infer<
  typeof postFundingSourceRequestSchema
>;

export const postFundingSourceResponseSchema = postFundingSourceRequestSchema
  .pick({
    account_number: true,
    account_type: true,
    customer_account_id: true,
    routing_number: true,
  })
  .extend({
    funding_source_id: zSchema.string(),
  });

export type TPostFundingSourceResponseSchema = zSchema.infer<
  typeof postFundingSourceResponseSchema
>;
